
import Otp from '~/pages/_lang/otp'
export default Otp
